module.exports = __webpack_public_path__ + "img/homepage-content-image-ford.ba91b428.jpg";